/**
 * Icon Cards — prevent navigation on cards without href; same visuals as linked cards.
 */
class IconCards extends HTMLElement {
  connectedCallback() {
    this._onClick = this._onClick.bind(this);
    this.querySelectorAll('.icon-card:not([href])').forEach((card) => {
      card.addEventListener('click', this._onClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('.icon-card:not([href])').forEach((card) => {
      card.removeEventListener('click', this._onClick);
    });
  }

  _onClick(event) {
    event.preventDefault();
  }
}

if (!customElements.get('icon-cards')) {
  customElements.define('icon-cards', IconCards);
}
